const styles = {
  characterisctics: {
    display:"flex",
    alignItems:"center"
  },
  paginate: { gap: "10px", marginTop: "20px", marginBottom: "0px" },
  modal_form: {
    width: "100%",
  },
  error_message: {
    color: "red",
  },
  button: {
    marginTop: "20px",
  },
  radioMargin: {
    marginTop: "20px"
  },
  radioPadding: {
    padding: "5px",
    marginLeft: "7px",
  },
  classCellWidth: {
  },
  removeButton: {
    color: "red", background: "none",
  },
  roleCellWidth: {
  },
  PupilImportFiled: {
    width: "651px",
    height: "51px",
    position: "inherit",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "50px 106px 71px 121px",
    borderRadius: "50px",
    border: "1px solid #fff",
    background: "#f2f2f2"
  },
  PupilImportCard: {
    width: "878px",
    borderRadius: "15px",
    backgroundColor: "#26C8B9",
  },
  PupilImportDiv: {
    marginLeft: "90px",
    marginTop: "130px"
  },
  PupilImportRow: {
    display: "flex",
    justifyContent: "center"
  },
  inviteUserCol: {
    display: "flex",
    flexDirection: "column",
  },
  inviteUserSelectDiv: {
    display: "flex",
    flexDirection: "row",
  },
  inviteUserSelectClass: {
    width: "48%",
    marginRight: "10px",
    fontWeight: "bold"
  },
  inviteUserSelectSub: {
    width: "48%",
    fontWeight: "bold"
  },
  inviteUserSelectResult:{
    width: "48%",
    marginRight: "20px",
  },
  inviteUserMar: {
    marginTop: "20px"
  },
  addButton:{
    width:"200px",
    height:"50px",
  }
    
}

const tableSize=10;
const tableSizeP=12;
export { styles ,tableSize, tableSizeP};

